import { useTranslation } from 'react-i18next';

interface AuthLoadingSpinnerProps {
  message?: string;
}

export default function AuthLoadingSpinner({ message }: AuthLoadingSpinnerProps) {
  const { t } = useTranslation(['auth', 'common']);

  const displayMessage = message ?? t('auth:redirectingToLogin');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center">
        <h1 className="text-2xl font-bold text-uel-purple-700 dark:text-uel-purple-400 mb-2">
          {t('common:appName')}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-sm mb-8">
          {t('common:appFullName')}
        </p>

        <div className="flex items-center space-x-2 mb-4" aria-hidden="true">
          <span className="w-3 h-3 bg-uel-purple-500 rounded-full loading-dot" />
          <span className="w-3 h-3 bg-uel-purple-500 rounded-full loading-dot" />
          <span className="w-3 h-3 bg-uel-purple-500 rounded-full loading-dot" />
        </div>

        <p className="text-gray-500 dark:text-gray-400 text-sm">
          {displayMessage}
        </p>
      </div>
    </div>
  );
}
